import app from "@/main";
import { INITIAL_ROUTE } from "@/store/modules/user/consts";

function doesContainCode() {
  const containsAuthCode = window.location.href.split("?code=");
  if (containsAuthCode[1]) {
    return true;
  }
  return false;
}

function doesHaveAccessToken() {
  const rkflAccess =
    app.config.globalProperties.$DbStorage.getItem("rocketfuel_access");
  if (rkflAccess) {
    return true;
  }
  return false;
}

function doesHaveParentOpener() {
  // eslint-disable-next-line no-unneeded-ternary
  return window.opener ? true : false;
}

export default function auth({ next, store }) {
  // Safari can occasionally race/hydrate auth state: tokens may be available
  // while `state.status` is still the initial value. Fall back to persisted
  // `rocketfuel_status` so verified users aren't incorrectly redirected.
  const storedStatus =
    app.config.globalProperties.$DbStorage.getItem("rocketfuel_status");
  const effectiveStatus =
    storedStatus !== null && storedStatus !== undefined && storedStatus !== ""
      ? storedStatus
      : store.getters["auth/userStatus"];
  const hasUserStatus = (() => {
    const n = Number(effectiveStatus);
    if (!Number.isNaN(n)) return n !== 0;
    return !!effectiveStatus;
  })();

  // For Safari fix
  if (doesHaveParentOpener() && !doesHaveAccessToken() && doesContainCode()) {
    window.opener.location.href = window.location.href;
    window.close();
  }
  if (store.getters["auth/isAuth"] && !hasUserStatus) {
    return next({
      name: "EmailConfirm",
    });
  }
  if (
    !store.getters["auth/isAuth"] &&
    !store.getters["auth/userStatus"] &&
    !INITIAL_ROUTE.some((route) => window.location.pathname.includes(route))
  ) {
    return next({
      name: "Welcome",
    });
  }
  return next();
}
